module.exports = __webpack_public_path__ + "static/media/postmanLogo.ab969e33.png";